import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { HOME_HASH_SECTION_IDS } from '../lib/homeSectionNavigation';

/** Scroll to top on route changes; homepage hash sections are handled by useHomeHashScroll. */
export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/') {
      const sectionId = decodeURIComponent((location.hash || '').replace(/^#/, '').trim());
      if (sectionId && HOME_HASH_SECTION_IDS.has(sectionId)) {
        return;
      }
    }

    window.scrollTo(0, 0);
  }, [location.pathname, location.key]);

  return null;
}
